import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import _pick from "lodash/pick";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import HtmlToNds, { NDSLib } from '@nerdwallet/react-html-to-nds';
import { Link } from '@nerdwallet/currency';
/**
 * Mappings that represent the html that we allow from custom content
 */

var HTML_WHITELIST = _objectSpread({}, _pick(NDSLib, 'a', // anchor
'b', // bold
'br', // break
'i', // italic
'li', // list item
'ol', // ordered list
'p', // paragraph
'ul', // unordered list
'&reg;', // ®
'&copy;' // ©
)); // for allowing http links


var UNSAFE_ANCHOR_TRANSFORM = function UNSAFE_ANCHOR_TRANSFORM(node, children) {
  return /*#__PURE__*/React.createElement(Link, _extends({
    rel: "noopener noreferrer"
  }, _pick(node.attribs, ['href', 'title', 'target'])), children);
};

var ContentSanitizer = function ContentSanitizer(_ref) {
  var html = _ref.html,
      respectUnsafeHref = _ref.respectUnsafeHref;

  var htmlWhitelist = _objectSpread({}, HTML_WHITELIST);

  if (!html) {
    return null;
  }

  if (respectUnsafeHref) {
    htmlWhitelist.a = UNSAFE_ANCHOR_TRANSFORM;
  }

  return /*#__PURE__*/React.createElement(HtmlToNds, {
    html: html,
    componentDict: htmlWhitelist,
    forceWhitelist: true
  });
};

ContentSanitizer.propTypes = {
  html: PropTypes.string,
  respectUnsafeHref: PropTypes.bool
};
ContentSanitizer.defaultProps = {
  html: '',
  respectUnsafeHref: false
};
export default ContentSanitizer;